import dayjs from 'dayjs';
import { DEFAULT_INTERVAL } from 'shared/time';

/**
 * Get first available date based on interval
 * */
const getNearestDateByInterval = ({
	date,
	minutesInterval = DEFAULT_INTERVAL,
}: {
	date: Date;
	minutesInterval?: number;
}): Date => {
	const startDate = new Date();

	startDate.setMinutes(0, 0, 0);

	let startDayInMs = startDate.getTime();
	let fromDateInMs = date.getTime();

	while (startDayInMs < fromDateInMs) {
		startDayInMs += minutesInterval * 60 * 1000;
	}

	return dayjs(startDayInMs).toDate();
};

export default getNearestDateByInterval;
